/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  app.ts
 * @Package :
 * @author:青瞳科技
 * @date:   2022/1/19 11:26
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 青瞳科技
 * 注意：本内容仅限于深圳青瞳科技有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

import { getShoppingCount } from "@/api/cykjStore";

const app = {
  state: {
    // includedComponents: ['ShopHomeLayout', 'OrderManage', 'ShareHomeLayout'],
    // ShopHomeLayout 不做缓存
    includedComponents: ['OrderManage', 'ShareHomeLayout'],
    transition: 'turn-on',
    isFullMode: true, // 企业商城是否是完整模式
    providerId: '', // 企业商城店铺编号
    loading: 0, // 当前正在请求的接口数量==>控制loading是否显示
    rootPath: '/shopMallOrder', // 应用路由 /首页 或全部应用页面
    shopCarNum: 0, // 购物车数量
    routerAliveStatus: true, // 是否需要无感刷新页面
    safetyHeight: 0, //
    topSafetyHeight: 0, // 顶部安全高度
    bottomSafetyHeight: 0, // 底部安全高度
    tabModules: [], // 底部导航模块
    isAgreeMessageProtect: false, // 是否同意个人信息保护提示
    isMultiStore: false, // 是否多店总览模式
    multiStoreList: [], // 多店总览选中的店铺列表
    keepAlivePages: [], // 保持活动页面
    sendSmsCodeTimes: [], // 发送验证码时间数组
    aiSourceUrl: process.env.VUE_APP_AI_URL // ai访问地址
  },
  mutations: {
    SET_INCLUDED_COMPONENTS: (state: any, includedComponents: string[]) => {
      state.includedComponents = includedComponents
    },
    SET_TRANSITION (state: any, transition: string) {
      state.transition = transition
    },
    SET_IS_FULL_MODE: (state: any, isFullMode: boolean) => {
      state.isFullMode = isFullMode
    },
    SET_PROVIDER_ID: (state: any, providerId: string) => {
      state.providerId = providerId
    },
    ADD_LOADING: (state: any) => {
      state.loading++
    },
    SUB_LOADING: (state: any) => {
      state.loading >0 ? state.loading-- : state.loading
    },
    CLEAR_LOADING: (state: any) => {
      state.loading = 0
    },
    SAVE_ROOT_PATH: (state: any,rootPath:string) => {
      state.rootPath = rootPath
    },
    SET_ROUTER_ALIVE: (state:any, routerALive:boolean) => {
      console.log('执行了');

      state.routerAliveStatus = routerALive
    },
    SET_SAFETY_HEIGHT: (state: any, safetyHeight: number) => {
      state.safetyHeight = safetyHeight
    },
    SET_TOP_SAFETY_HEIGHT: (state: any, topSafetyHeight: number) => {
      state.topSafetyHeight = topSafetyHeight
    },
    SET_BOTTOM_SAFETY_HEIGHT: (state: any, bottomSafetyHeight: number) => {
      state.bottomSafetyHeight = bottomSafetyHeight
    },
    SET_TAB_MODULES: (state: any, modules: Array<any>) => {
      state.tabModules = modules
    },
    GET_SHOP_CAR_NUM: (state: any, shopCarNum:number) => {
      state.shopCarNum = shopCarNum
    },
    SET_IS_AGREE_MESSAGE_PROTECT: (state: any, isAgreeMessageProtect: boolean) => {
      state.isAgreeMessageProtect = isAgreeMessageProtect
    },
    SET_IS_MULTI_STORE: (state: any, isMultiStore: boolean) => {
      state.isMultiStore = isMultiStore
    },
    SET_MULTI_STORE_LIST: (state: any, list: (string | number)[]) => {
      state.multiStoreList = list
    },
    addKeepAlive(state: any, val: string) {
      if (!state.keepAlivePages.includes(val)) {
        state.keepAlivePages.push(val);
      }
    },
    delKeepAlive(state: any, val: string) {
      state.keepAlivePages = state.keepAlivePages.filter((path) => path !== val);
    },
    setSendSmsCodeTimes: (state: any, list: (string | number)[]) => {
      state.sendSmsCodeTimes = list
    },
    SET_AI_SOURCE_URL: (state: any, aiSourceUrl: string) => {
      state.aiSourceUrl = aiSourceUrl
    }
  },
  actions: {
    setIncludedComponents ({commit}: any, includedComponents: string[]) {
      commit('SET_INCLUDED_COMPONENTS', includedComponents)
    },
    /* 重置keep-alive缓存 */
    resetIncludedComponents ({commit}: any) {
      commit('SET_INCLUDED_COMPONENTS', ['ShopHomeLayout', 'OrderManage', 'ShareHomeLayout'])
    },
    setTransition ({commit}: any, transition: string) {
      commit('SET_TRANSITION', transition)
    },
    setIsFullMode ({commit}: any, isFullMode: boolean) {
      commit('SET_IS_FULL_MODE', isFullMode)
    },
    setProviderId ({commit}: any, providerId: string) {
      commit('SET_PROVIDER_ID', providerId)
    },
    setRootPath ({commit}: any, rootPath: string) {
      commit('SAVE_ROOT_PATH', rootPath)
    },
    setRouterAlive ({commit}: any, routerAlive: boolean) {
      commit('SET_ROUTER_ALIVE', routerAlive)
    },
    setSafetyHeight ({commit}: any, safetyHeight: number) {
      commit('SET_SAFETY_HEIGHT', safetyHeight)
    },
    setTopSafetyHeight ({commit}: any, topSafetyHeight: number) {
      commit('SET_TOP_SAFETY_HEIGHT', topSafetyHeight)
    },
    setBottomSafetyHeight ({commit}: any, bottomSafetyHeight: number) {
      commit('SET_BOTTOM_SAFETY_HEIGHT', bottomSafetyHeight)
    },
    setTabModules ({commit}: any, modules: Array<any>) {
      commit('SET_TAB_MODULES', modules)
    },
    setIsAgreeMessageProtect ({commit}: any, isAgreeMessageProtect: boolean) {
      commit('SET_IS_AGREE_MESSAGE_PROTECT', isAgreeMessageProtect)
    },
    setIsMultiStore ({commit}: any, isMultiStore: boolean) {
      commit('SET_IS_MULTI_STORE', isMultiStore)
    },
    setMultiStoreList ({commit}: any, list: (string | number)[]) {
      commit('SET_MULTI_STORE_LIST', list)
    },
    async getShopCarNum ({commit}: any,partnerCompanyId:any) {
      await getShoppingCount({ partnerCompanyId }).then((res:any) => {
        if (res.code==='000000') {
          commit('GET_SHOP_CAR_NUM', res.data.shoppingCount)
        }
      })
    }
  },
}

export default app
